import React, {useState} from 'react';
import {SourceContext} from '../context';

// eslint-disable-next-line react/prop-types
const DocsetContextProvider = ({children}) => {
  const [docset, setDocset] = useState('');

  return (
    <SourceContext.Provider value={{docset, setDocset}}>
      {children}
    </SourceContext.Provider>
  );
};

export default DocsetContextProvider;
